// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"85f881a0","180":"9e762046","208":"53cfede3","631":"2f3024c1","774":"66c7c4a8","787":"cbe962be","820":"95d30a49","910":"7a78f69c"}[chunkId] + ".chunk.js";
};